import { useEffect, useMemo, useState } from 'react'
import ReportFilterBar from 'components/ReportFilterBar'
import { Card, CardBody, CardHeader } from 'reactstrap'
import useProcessFilters from './hooks/useProcessFilters'
import DownloadReportButton from 'components/DownloadReportButton'
import useInitFormats from './hooks/useInitFormats'
import { getCustomData } from 'shared/components/App/Auth'
import ChildFilterErrors from 'types/ChildFilterErrors'
import useDisplayChildFilterErrors from './hooks/useDisplayChildFilterErrors'
import usePopulateAis from './hooks/usePopulateAis'
import AisReportProps from './types/AisReportProps'
import { IonIcon } from '@ionic/react'
import  { bulb } from 'ionicons/icons'

interface ReportProps {
  aisReport?: AisReportProps
  id: number
  vslzId: number
  name: string
  height: string
  formats: Array<string>
  token: string | false
  pageFilterParams?: any
  isPageFilterBarLoaded: boolean
  isLoaded?: Function
  filterChangeTime: string | false,
  childFilterPageErrorMessage?: string | null
  loadedPageFilterCount: null | number
}

const Report: React.FunctionComponent<ReportProps> = (props: ReportProps) => {
  const [filterParams, setFilterParams] = useState<any>({})
  const [allFilterParams, setAllFilterParams] = useState<any>({})
  const [reportUrl, setReportUrl] = useState<string>('')
  const [reportQueryString, setReportQueryString] = useState<string>('')
  const [isLoaded, setIsLoaded] = useState<boolean>(false)
  const [showIframeLoading, setShowIframeLoading] = useState<boolean>(true)
  const [formats, setFormats] = useState<Array<{ id: string; name: string }>>([])
  const [filterChangeTime, setFilterChangeTime] = useState<string | false>(false)
  const [childFilterErrors, setChildFilterErrors] = useState<ChildFilterErrors>({})
  const [childFilterErrorMessage, setChildFilterErrorMessage] = useState<string | null>(null)
  const [ais, setAis] = useState<string>('')
  const [isAisLoading, setIsAisLoading] = useState<boolean>(false)
  const [reportFilterCount, setReportFilterCount] = useState<null | number>(null)

  const ischildFilterErrorMessageNull: boolean = useMemo(() => childFilterErrorMessage === null, [childFilterErrorMessage]);

  const eulaAccepted = getCustomData('eulaAccepted')

  useProcessFilters({
    filterParams,
    allFilterParams,
    setAllFilterParams,
    pageFilterParams: props.pageFilterParams,
    setReportUrl,
    setReportQueryString,
    reportId: props.vslzId,
    token: props.token,
    height: props.height,
    isLoaded,
    isPageFilterBarLoaded: props.isPageFilterBarLoaded,
    reportFilterCount: reportFilterCount,
    pageFilterCount: props.loadedPageFilterCount
  })

  useDisplayChildFilterErrors({
    setChildFilterErrorMessage,
    childFilterPageErrorMessage: props.childFilterPageErrorMessage,
    childFilterErrors,
  })

  usePopulateAis({
    reportQueryString,
    aisReport: props.aisReport,
    ischildFilterErrorMessageNull,
    setAis,
    setIsAisLoading,
  })

  const setFilterParam = (param: string, value?: string | Array<string>) => {
    setFilterParams(prevState => {
      if (!Array.isArray(value) && [undefined, null, ''].includes(value)) {
        const { [param]: _, ...rest } = prevState;
        //prepare empty string that will not be passed to a query string later in useProcessFilters
        return { ...rest, [param]: '' };
      } else {
        return { ...prevState, [param]: value }
      }
    })
  }

  useInitFormats({
    formats: props.formats,
    setFormats,
  })

  useEffect(() => {
    if (props.isLoaded && isLoaded) {
      props.isLoaded(props.name)
    }
  }, [isLoaded])

  useEffect(() => {
    setFilterChangeTime(props.filterChangeTime)
  }, [props.filterChangeTime])

  useEffect(() => {
    if (filterChangeTime) {
      setShowIframeLoading(true)
    }
  }, [filterChangeTime])



  return (
    <div className='report'>
      <Card className='report'>
        <CardHeader className='main'>
          <h4>{props.name}</h4>
          <div className='d-flex'>
            <ReportFilterBar
              id={props.id}
              setFilterParam={setFilterParam}
              parentFilterParams={allFilterParams}
              isLoaded={setIsLoaded}
              setFilterChangeTime={setFilterChangeTime}
              setChildFilterErrors={setChildFilterErrors}
              setLoadedFilterCount={setReportFilterCount}
            />
            {props.formats.length > 0 && (
              <DownloadReportButton id={props.id} isLoaded={setIsLoaded} formats={formats} reportQueryString={reportQueryString} />
            )}
          </div>
        </CardHeader>
        <CardBody className='iframe-body'>
          {ischildFilterErrorMessageNull && reportUrl.length > 0 && <iframe src={reportUrl} height={props.height === 'full' ? '800px' : props.height} className='report-iframe' onLoad={() => setShowIframeLoading(false)} />}
          {ischildFilterErrorMessageNull && showIframeLoading && <div className='loading-cont'><img src="/images/loading.svg" className='loading' alt="Application Loading..." /></div>}
          {!ischildFilterErrorMessageNull && <div className='lead text-center'>{childFilterErrorMessage}</div>}

          <div className={isAisLoading ? 'ais-container is-loading' : 'ais-container'}>
            {ischildFilterErrorMessageNull && props.aisReport !== null && (
              <>
                <h6><IonIcon icon={bulb} className='ionicon' style={{color: '#ffd431', fontSize: '14px'}} /> Alairo Intelligence Summary:</h6>
                {isAisLoading 
                ? (<div className='loading-cont'><img src="/images/loading.svg" className='loading' alt="Application Loading..." /></div>)
                : (<p dangerouslySetInnerHTML={{ __html: ais }} />)}
              </>
            )}
          </div>
        </CardBody>

      </Card>
    </div>
  )
}

export default Report
